import React from "react";
import { Col, Row } from "reactstrap";

export const ReviewFilterTabs = ({
    show = false,
    tabs = [],
    activeValue,
    onChange,
}) => {
    if (!show) return null;

    return (
        <Row className="mb-3">
            <Col md={12}>
                <div className="review-tabs-modern mx-auto">
                    {tabs.map((tab) => (
                        <button
                            key={tab.value}
                            type="button"
                            className={`review-tab-btn ${tab.tone === "danger" ? "review-tab-btn--danger" : ""} ${activeValue === tab.value ? "active" : ""}`}
                            onClick={() => onChange(tab.value)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </Col>
        </Row>
    );
};

export const CategoryFilterTabs = ({
    show = false,
    tabs = [],
    activeValue,
    totalsByCode = {},
    onChange,
}) => {
    if (!show || tabs.length === 0) return null;

    return (
        <Row className="mb-3">
            <Col md={12}>
                <div className="category-tabs-modern">
                    {tabs.map((tab) => {
                        const tabCode = String(tab.value || "").toUpperCase();
                        const total = totalsByCode[tabCode] ?? 0;
                        return (
                            <button
                                key={tab.value}
                                type="button"
                                className={`category-tab-btn ${activeValue === tab.value ? "active" : ""}`}
                                onClick={() => onChange(tab.value)}
                            >
                                <span className="category-tab-label">{tab.label}</span>
                                <span className="category-tab-code">Total {total}</span>
                            </button>
                        );
                    })}
                </div>
            </Col>
        </Row>
    );
};
